/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Panel_BodyInputs */

const en_login_panel_body = /** @type {(inputs: Login_Panel_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Characterful apartments in the heart of the city, with a local team here when you need us.`)
};

/**
* | output |
* | --- |
* | "Characterful apartments in the heart of the city, with a local team here when you need us." |
*
* @param {Login_Panel_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const login_panel_body = /** @type {((inputs?: Login_Panel_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Panel_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_login_panel_body(inputs)
});